import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NeproseService } from '../services/neprose.service';

@Component({
  selector: 'app-request-password-change',
  templateUrl: './request-password-change.component.html',
  styleUrls: ['./request-password-change.component.css']
})
export class RequestPasswordChangeComponent implements OnInit {

  form: FormGroup

  phone: FormControl = new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)])

  formInput = ['input1', 'input2', 'input3', 'input4'];
  
  @ViewChildren('formRow') rows: any;

  showVerificationBox: boolean

  constructor( private authService: AuthService, private _notification: MatSnackBar, private router: Router, private _neproseService: NeproseService,
    @Inject(PLATFORM_ID) protected platformId: Object, private route: ActivatedRoute) {
    this.form = this.toFormGroup(this.formInput)
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        if(params.phone && (params.phone.length == 10)) {
          this.phone.setValue(params.phone)
          this.showVerificationBox = true
        }
      });
  }

  toFormGroup(elements) {
    const group: any = {};
    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
   }

  verifyUser(code){
    this.authService.requestPasswordChangeToken(this.phone.value, code).subscribe(data => {
      if(data.status){
        this.router.navigate(['change-password'], {queryParams: { token: data.accessToken }})
      }
    }, error => {
      if(error.error){
        if(error.status == 400){
          this.openNotification(error.error.msg);
        }
      }
    })
  }

  goToNextInput(event, index){
    if(isPlatformBrowser(this.platformId)){
      var value = event.target.value
      let pos = index;
      if (event.keyCode === 8 && event.which === 8) {
        pos = index - 1 ;
      }else {
        if(parseInt(value) || (parseInt(value) == 0)){
          pos = index + 1 ;
        }else{
          event.preventDefault()
        } 
      }
      if (pos > -1 && pos < this.formInput.length ) {
        this.rows._results[pos].nativeElement.focus();
      }
    } 
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  onSubmit() {
    var values = this.form.value
    var code = ''
    for(let key in values){
      code = code + values[key]
    }
    this.verifyUser(code)
  }


  requestPasswordChange(){
    this.authService.requestPasswordChange(this.phone.value).
      subscribe(
        data => {
          if(data.status){
            this.router.navigate(['reset-password'], {queryParams: { phone: this.phone.value }})
            this.openNotification("Please check your message box.")
            this.showVerificationBox = true
          }
        }, error =>{
          if(error.status == 400){
            this.openNotification(error.error.message)
          }
        }
      )
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
